// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2bI7u","title":"BackImages_title__G5DKp","images":"BackImages_images__1Cshs"};